class Sharer {
    build_uri(element) {
        const uri = {
            Twitter: (element, url) => {
                let uri = `?original_referer=${url}&url=${url}&tw_p=tweetbutton`;

                if (s = element.getAttribute('data-text')) uri += `&text=${s}`;
                if (s = element.getAttribute('data-via')) uri += `&via=${s}`;

                return uri;
            },
            Facebook: (element, url) => { return `?u=${url}` },
            Instagram: (element, url) => { return `?u=${url}` },
            Linkedin: (element, url) => {
                let uri = `?url=${url}&mini=true`

                if (s = element.getAttribute('data-title')) uri += `&title=${s}`;
                if (s = element.getAttribute('data-summary')) uri += `&summary=${s}`;
                if (s = element.getAttribute('data-source')) uri += `&source=${s}`;

                return uri;
            }
        }

        return `${element.href}` + uri[this.name](
            element, encodeURIComponent(window.location.href))

    }

    build_window_features(w, h) {
        const dual_screen_left = window.screenLeft !==  undefined ?
            window.screenLeft : window.screenX;
        const dual_screen_top = window.screenTop !==  undefined   ?
            window.screenTop  : window.screenY;

        const width = window.innerWidth ?
            window.innerWidth : document.documentElement.clientWidth ?
                document.documentElement.clientWidth : screen.width;
        const height = window.innerHeight ?
            window.innerHeight : document.documentElement.clientHeight ?
                document.documentElement.clientHeight : screen.height;

        let features = `location=0,menubar=0,status=0,scrollbars=0,toolbar=0`

        const system_zoom = width/window.screen.availWidth;
        features += `,height=${h/system_zoom}`;
        // features += `,height=${h}`;
        features += `,width=${w/system_zoom}`;
        // features += `,width=${w}`;

        const top = (height - h)/2/system_zoom + dual_screen_top
        // const top = (height - h)/2
        features += `,top=${top}`;

        const left = (width - w)/2/system_zoom + dual_screen_left
        // const left = (width - w)/2
        features += `,left=${left}`;

        return features
    }

    constructor(selector, name) {
        this.selector = document.querySelectorAll(selector);
        this.name = name

        this.selector.forEach((element, i) => {
            element.addEventListener('click', event => {
                if (event.preventDefault) event.preventDefault()

                new_window = window.open(
                    this.build_uri(element),  // url
                    this.name,  // target
                    this.build_window_features(550, 420)  // features
                )

                if (window.focus) new_window.focus();
            })
        })
    }
}

new Sharer('.twitter-button', 'Twitter')
new Sharer('.facebook-button', 'Facebook')
new Sharer('.linkedin-button', 'Linkedin')
new Sharer('.instagram-button', 'Instagram')
